import { supabase } from '../supabaseClient';

export const parseScheduleImage = async (base64Image: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('analyze-schedule', {
      body: { imageBase64: base64Image },
    });

    if (error) {
      console.error("Supabase Edge Function Error:", error);
      let errorMsg = error.message || "Failed to analyze image";
      
      try {
        // Edge functions sometimes return the JSON body in the error message string
        if (typeof errorMsg === 'string' && errorMsg.includes('{')) {
            const parsed = JSON.parse(errorMsg);
            if (parsed.error) errorMsg = parsed.error;
        }
      } catch (e) {
          // Ignore JSON parse errors here
      }

      if (errorMsg === 'QUOTA_EXCEEDED') {
        throw new Error('QUOTA_EXCEEDED');
      }
      throw new Error(errorMsg);
    }

    // The edge function should return the parsed data array directly
    if (!data || !Array.isArray(data)) {
      throw new Error("Invalid response format from server.");
    }

    return data;

  } catch (error: any) {
    console.error("Gemini OCR Error Raw:", error);

    // Provide a generic fallback error if it's not our specific quota error
    if (error.message !== 'QUOTA_EXCEEDED') {
         throw new Error("Failed to analyze image.");
    }

    throw error;
  }
};


export const searchPlacesWithMaps = async (query: string, location?: { lat: number, lon: number }) => {
  try {
    const { data, error } = await supabase.functions.invoke('search-places', {
      body: { query, location }
    });

    if (error) {
      console.error("Supabase Edge Function Error:", error);
      let errorMsg = error.message;
      try {
        if (typeof errorMsg === 'string' && errorMsg.includes('{')) {
          const parsed = JSON.parse(errorMsg);
          if (parsed.error) errorMsg = parsed.error;
        }
      } catch (e) {}

      if (errorMsg === 'QUOTA_EXCEEDED') throw new Error('QUOTA_EXCEEDED');
      throw new Error(errorMsg);
    }

    return data;
  } catch (error: any) {
    console.error("Gemini Maps Error:", error);
    let errorMessage = error?.message || "Erro desconhecido";
    
    if (errorMessage.includes('QUOTA_EXCEEDED')) {
      throw new Error("QUOTA_EXCEEDED");
    }
    throw new Error("Failed to search places.");
  }
};
